import { useTranslation } from 'react-i18next'
import { clientConfigurationProvider as getConfigValue } from '@ocean/configs'
import { common } from '@ocean/ui'
import { PromoInfo } from 'components/common'
import { AnimatedSection } from 'modules/Auth/components'
import { namespace } from 'modules/Auth/localization'
import { Container, VersionWrapper } from './AuthFooter.styled'

const { Typography } = common
const I18_PATH = `${namespace}:auth.login`

const AuthFooter: React.FC = () => {
  const { t } = useTranslation()
  const appVersion = getConfigValue('appVersion')
  return (
    <Container>
      <AnimatedSection animationDuration='1.1s'>
        <PromoInfo />
        <VersionWrapper>
          <Typography variant='small' color='white' dataTest='AuthFooterVersion'>
            {t(`${I18_PATH}.version`, { version: appVersion })}
          </Typography>
        </VersionWrapper>
      </AnimatedSection>
    </Container>
  )
}

export default AuthFooter
